// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.prescription.AuthorizeContactLensPrescriptionRequest */
/* istanbul ignore next */
@GandalfModel
export class AuthorizeContactLensPrescriptionRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Contact Lens Trial is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	contactLensPrescriptionId!: number;

	@GandalfValidator({ notNull: { message: 'Use Provider Signature is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	useSignature!: boolean;

}
